(() => {
  const TAG = '[Gallery Startup]';

  const FORCE_SECOND_IMAGE = true;

  function isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function getVisibleGalleries() {
    return Array.from(document.querySelectorAll('media-gallery')).filter((gallery) => {
      const rect = gallery.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
  }

  function getSlides(gallery) {
    const slider = gallery.querySelector('[id^="Slider-Gallery"]');

    if (!slider) return [];

    return Array.from(slider.children).filter((child) => {
      return child.matches('[data-media-id]');
    });
  }

  function getTargetMediaId(gallery) {
    const slides = getSlides(gallery);

    if (!slides.length) return null;

    if (FORCE_SECOND_IMAGE) {
      return slides[1]?.dataset.mediaId || slides[0]?.dataset.mediaId || null;
    }

    return gallery.dataset.startupMediaId || slides[1]?.dataset.mediaId || slides[0]?.dataset.mediaId || null;
  }

  function activateGallery(gallery) {
    const targetMediaId = getTargetMediaId(gallery);

    if (!targetMediaId) {
      console.warn(`${TAG} No target media found`, gallery);
      return;
    }

    if (typeof gallery.setActiveMedia !== 'function') {
      console.warn(`${TAG} setActiveMedia not ready`, gallery);
      return;
    }

    const shouldPrepend = isDesktop();

    // 👇 SCROLLING WALA FUNCTION YAHAN ROK DIYA GAYA HAI 👇
    // gallery.setActiveMedia(targetMediaId, shouldPrepend);

    // console.log(`${TAG} Activated`, {
    //   targetMediaId,
    //   desktop: isDesktop(),
    //   prepend: shouldPrepend,
    //   gallery,
    // });
  }

  function run() {
    const galleries = getVisibleGalleries();

    if (!galleries.length) {
      console.warn(`${TAG} No visible media-gallery found`);
      return;
    }

    galleries.forEach((gallery) => {
      activateGallery(gallery);
    });
  }

  function delayedRun() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        run();

        setTimeout(run, 300);
        setTimeout(run, 800);
        setTimeout(run, 1500);
        setTimeout(run, 2500);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', delayedRun);
  } else {
    delayedRun();
  }

  window.addEventListener('load', delayedRun);

  document.addEventListener('shopify:section:load', delayedRun);
  document.addEventListener('product-info:loaded', delayedRun);

  window.addEventListener('resize', () => {
    setTimeout(delayedRun, 300);
  });
})();